var React = require('react');

function GeoLocation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.50005 13.4998c-.06678 0-.13289-.0133-.19443-.0393-.06153-.0259-.11724-.0639-.16385-.1117-.0466-.0479-.08316-.1045-.1075-.1667s-.03598-.1286-.03422-.1954v-5.73282c0-.0663-.02634-.12989-.07323-.17678-.04688-.04688-.11047-.07322-.17677-.07322h-5.73719c-.105164.00125-.208137-.03007-.294801-.08965-.086663-.05959-.152772-.14452-.189262-.24316-.041555-.11763-.037634-.24655.010992-.36144.048627-.11488.138446-.20744.251821-.2595l11.99999-5.504687c.0927-.042479.1962-.055593.2966-.037585.1004.018009.1928.06628.265.138339.0721.072059.1205.16446.1387.264811.0181.100352.0052.203852-.0372.296622l-5.49997 11.99997c-.03982.0872-.10385.1611-.18446.2129s-.1744.0793-.27022.0793z","fill":"#1f2e5c"}));
}

GeoLocation.defaultProps = {"fill":"none","height":"14","viewBox":"0 0 14 14","width":"14"};

module.exports = GeoLocation;

GeoLocation.default = GeoLocation;
